module.exports = __webpack_public_path__ + "static/media/profile_image.3ca40268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/profile_image.jpg
// module id = 221
// module chunks = 0